export enum ValidateableCvSections {
    Summary = 1,
    ProjectExperience = 2,
    Education = 3,
    WorkExperience = 4,
    Certifications = 5,
    Languages = 6,
    Trainings = 7,
}
